import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Appscreen() {
  const [videoLoaded, setVideoLoaded] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setVideoLoaded(true);
          observer.disconnect(); // Stop observing once the video is loaded
        }
      },
      { threshold: 0.1 } // Adjust the threshold as needed
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (observer && sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return (
    <section className="app-screen p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="text-center">
            <h2 style={{ color: "#333333" }}>App Screens</h2>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="app-screen-main">
              <div className="app-screen-item">
                <StaticImage
                  src="../../../images/case-studies/rise-up-king/mob-1.webp"
                  alt="TekRevol"
                  className="logo_amj"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={352}
                  height={724}
                />
              </div>
              <div className="app-screen-item">
                <StaticImage
                  src="../../../images/case-studies/rise-up-king/mob-2.webp"
                  alt="TekRevol"
                  className="logo_amj"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={352}
                  height={724}
                />
              </div>
              <div className="app-screen-item">
                <StaticImage
                  src="../../../images/case-studies/rise-up-king/mob-3.webp"
                  alt="TekRevol"
                  className="logo_amj"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={352}
                  height={724}
                />
              </div>
              <div className="app-screen-item">
                <StaticImage
                  src="../../../images/case-studies/rise-up-king/mob-4.webp"
                  alt="TekRevol"
                  className="logo_amj"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={352}
                  height={724}
                />
              </div>
              <div className="app-screen-item">
                <StaticImage
                  src="../../../images/case-studies/rise-up-king/mob-5.webp"
                  alt="TekRevol"
                  className="logo_amj"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={352}
                  height={724}
                />
              </div>
              <div className="app-screen-item">
                <StaticImage
                  src="../../../images/case-studies/rise-up-king/mob-6.webp"
                  alt="TekRevol"
                  className="logo_amj"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={352}
                  height={724}
                />
              </div>
              <div className="app-screen-item">
                <StaticImage
                  src="../../../images/case-studies/rise-up-king/mob-7.webp"
                  alt="TekRevol"
                  className="logo_amj"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={352}
                  height={724}
                />
              </div>
              <div className="app-screen-item">
                <StaticImage
                  src="../../../images/case-studies/rise-up-king/mob-8.webp"
                  alt="TekRevol"
                  className="logo_amj"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={352}
                  height={724}
                />
              </div>
              <div className="app-screen-item">
                <StaticImage
                  src="../../../images/case-studies/rise-up-king/mob-9.webp"
                  alt="TekRevol"
                  className="logo_amj"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={352}
                  height={724}
                />
              </div>
              <div className="app-screen-item">
                <StaticImage
                  src="../../../images/case-studies/rise-up-king/mob-10.webp"
                  alt="TekRevol"
                  className="logo_amj"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={352}
                  height={724}
                />
              </div>
              <div className="app-screen-item">
                <StaticImage
                  src="../../../images/case-studies/rise-up-king/mob-11.webp"
                  alt="TekRevol"
                  className="logo_amj"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={352}
                  height={724}
                />
              </div>
              <div className="app-screen-item">
                <StaticImage
                  src="../../../images/case-studies/rise-up-king/mob-12.webp"
                  alt="TekRevol"
                  className="logo_amj"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={352}
                  height={724}
                />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Appscreen;
